import { syncFavouritesToDB } from  "../../vue_js/helpers/favouritesSyncHelper.js";

(function ($) {
  const profileMenuBtn = document.getElementById("profile-menu-button");
  const headerFavouriteIcon = document.getElementById(
    "khst-header-favourite-icon"
  );

  if (profileMenuBtn) {
    profileMenuBtn.addEventListener("click", function (e) {
      if (profileMenuBtn.getAttribute("data-tixly-is-logged-in") !== "true") {
        return;
      }

      e.preventDefault();
      const profileMenu = document.getElementById("profile-menu");
      const chevronIcon = document.querySelector(".header__svg-chevron-icon");
      if (profileMenu) {
        profileMenu.classList.toggle("profile-menu--open");
        // Toggle rotation class on chevron icon
        chevronIcon.classList.toggle("header__svg-chevron-icon--open");
      }
    });
  }

  window.addEventListener(
    "message",
    (event) => {
      // Prevent multiple message calls
      let tix_iframe = document.getElementById("header__tix");
      if (tix_iframe) {
        if (tix_iframe.getAttribute("data-message-received") === "true") {
          // return;
        }
        tix_iframe.setAttribute("data-message-received", "true");
      }

      if (event.origin === "https://tix.kulturhusetstadsteatern.se") {
        let baseUrl = window.location.origin;
        let redirectUrl = baseUrl + "/login-redirect";
        let loginUrl = event.data.profile + "?ReturnUrl=" + redirectUrl;
        let profile_link = $(".header__profile-link");
        profile_link.attr("href", loginUrl);
        //profile_link.attr('href', event.data.profile);

        if (event.data.user === null) {
          let drupalUser = window.khstGetUser();
          if (drupalUser !== null) {
            logoutDrupalUser(drupalUser.csrf_token);
            localStorage.removeItem("drupal_user");
          }

          profile_link.addClass("login");
          profile_link.removeClass("logout");
          profile_link.find("span").text(Drupal.t("Log in"));
          profile_link.prepend(` <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="header__svg-profile-icon">
            <path d="M12.4688 13.0312C11.75 11.8125 10.4688 11 9 11H7C5.5 11 4.21875 11.8125 3.53125 13.0312C4.625 14.25 6.21875 15 8 15C9.75 15 11.3438 14.25 12.4688 13.0312ZM0 9C0 6.15625 1.5 3.53125 4 2.09375C6.46875 0.65625 9.5 0.65625 12 2.09375C14.4688 3.53125 16 6.15625 16 9C16 11.875 14.4688 14.5 12 15.9375C9.5 17.375 6.46875 17.375 4 15.9375C1.5 14.5 0 11.875 0 9ZM8 9.5C8.78125 9.5 9.53125 9.09375 9.9375 8.375C10.3438 7.6875 10.3438 6.84375 9.9375 6.125C9.53125 5.4375 8.78125 5 8 5C7.1875 5 6.4375 5.4375 6.03125 6.125C5.625 6.84375 5.625 7.6875 6.03125 8.375C6.4375 9.09375 7.1875 9.5 8 9.5Z" fill="black"/>
          </svg>`);

          /* Added localStorage for logged-out status */
          localStorage.setItem("loggedInFavouriteCheck", "false");

          // Append user account link to mobile navigation.
          if (
            $("ul.main-menu__primary").find(".profile-link-mobile").length == 0
          ) {
            $("ul.main-menu__primary").append(
              '<li class="menu-list__item profile-link-mobile"><a class="header__profile-link-mobile login menu-list main-menu__primary main-menu__top-level " href="' +
                loginUrl +
                '"><span>' +
                Drupal.t("Log in") +
                "</span></a></li>"
            );
          }
        } else {
          // If user is logged in Drupal but Empty in Tixly User Local Storage then remove the user from localstorage
          let drupalUser = window.khstGetUser();
          if (drupalSettings.user.uid === 0 && drupalUser !== null) {
            localStorage.removeItem("drupal_user");
            setTimeout(() => {
              window.location.href = redirectUrl; // Change this to your target URL
            }, 100);
          }
          if (localStorage.getItem("drupal_user") === null) {
            getDrupalUser(event.data.user);
          }
          getUserDetails();

          // Force dialog to show if user is not yet tagged and we're on the right URL
          if (
            !checkPendingTags(event.data.user.tags) &&
            window.location.pathname === "/mina-sidor"
          ) {
            const dialog = document.querySelector("#form-reg-dialog");
            if (dialog) {
              dialog.show();
            }
          }

          profile_link.addClass("logout");
          profile_link.removeClass("login");
          profile_link.find("span").text(event.data.user.name || "Mina sidor");
          profile_link.attr("data-tixly-is-logged-in", "true");
          if (!checkTags(event.data.user.tags)) {
            // Missing tag icon
            profile_link.prepend(`
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="header__svg-warning-icon">
              <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#FFF446"/>
              <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="black"/>
              <path d="M8.625 4.5V9.5C8.625 9.85156 8.33203 10.125 8 10.125C7.64844 10.125 7.375 9.85156 7.375 9.5V4.5C7.375 4.16797 7.64844 3.875 8 3.875C8.33203 3.875 8.625 4.16797 8.625 4.5ZM8 12.625C7.70703 12.625 7.45312 12.4883 7.31641 12.2344C7.17969 12 7.17969 11.707 7.31641 11.4531C7.45312 11.2188 7.70703 11.0625 8 11.0625C8.27344 11.0625 8.52734 11.2188 8.66406 11.4531C8.80078 11.707 8.80078 12 8.66406 12.2344C8.52734 12.4883 8.27344 12.625 8 12.625Z" fill="black"/>
            </svg>`);
            // Account icon
            profile_link.prepend(` <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="header__svg-profile-icon">
              <path d="M12.4688 13.0312C11.75 11.8125 10.4688 11 9 11H7C5.5 11 4.21875 11.8125 3.53125 13.0312C4.625 14.25 6.21875 15 8 15C9.75 15 11.3438 14.25 12.4688 13.0312ZM0 9C0 6.15625 1.5 3.53125 4 2.09375C6.46875 0.65625 9.5 0.65625 12 2.09375C14.4688 3.53125 16 6.15625 16 9C16 11.875 14.4688 14.5 12 15.9375C9.5 17.375 6.46875 17.375 4 15.9375C1.5 14.5 0 11.875 0 9ZM8 9.5C8.78125 9.5 9.53125 9.09375 9.9375 8.375C10.3438 7.6875 10.3438 6.84375 9.9375 6.125C9.53125 5.4375 8.78125 5 8 5C7.1875 5 6.4375 5.4375 6.03125 6.125C5.625 6.84375 5.625 7.6875 6.03125 8.375C6.4375 9.09375 7.1875 9.5 8 9.5Z" fill="black"/>
            </svg>`);
          } else {
            // If user does have a tag
            profile_link.prepend(` <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="header__svg-profile-icon">
              <path d="M12.4688 13.0312C11.75 11.8125 10.4688 11 9 11H7C5.5 11 4.21875 11.8125 3.53125 13.0312C4.625 14.25 6.21875 15 8 15C9.75 15 11.3438 14.25 12.4688 13.0312ZM0 9C0 6.15625 1.5 3.53125 4 2.09375C6.46875 0.65625 9.5 0.65625 12 2.09375C14.4688 3.53125 16 6.15625 16 9C16 11.875 14.4688 14.5 12 15.9375C9.5 17.375 6.46875 17.375 4 15.9375C1.5 14.5 0 11.875 0 9ZM8 9.5C8.78125 9.5 9.53125 9.09375 9.9375 8.375C10.3438 7.6875 10.3438 6.84375 9.9375 6.125C9.53125 5.4375 8.78125 5 8 5C7.1875 5 6.4375 5.4375 6.03125 6.125C5.625 6.84375 5.625 7.6875 6.03125 8.375C6.4375 9.09375 7.1875 9.5 8 9.5Z" fill="black"/>
            </svg>`);
          }
          // Arrow icon
          profile_link.append(`
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="header__svg-chevron-icon">
              <path d="M5.28125 5.71875L1.28125 1.71875C1 1.4375 0.90625 1 1.0625 0.625C1.21875 0.25 1.59375 0 2 0H10C10.4062 0 10.75 0.25 10.9062 0.625C11.0625 1 10.9688 1.4375 10.6875 1.71875L6.6875 5.71875C6.3125 6.125 5.65625 6.125 5.28125 5.71875Z" fill="black"/>
            </svg>
          `);

          // Append user account link to mobile navigation.
          if (
            $("ul.main-menu__primary-my-account").find(".profile-link-mobile")
              .length == 0
          ) {
            $("div.main-menu__wrapper").append(`
                  <p class="logged-in-as">
                    ${Drupal.t("Du är inloggad som")}</p>
                  <ul class="menu-list main-menu__primary-my-account main-menu__primary-my-account-mobile">
                      <li class="menu-list__item profile-link-mobile menu-item--expandable">
                          <button class="main-menu__top-level main-menu__trigger" style="display:flex; align-items: center; gap: 0.5rem;">
                            <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18.7031 19.0469C17.625 17.2188 15.7031 16 13.5 16H10.5C8.25 16 6.32812 17.2188 5.29688 19.0469C6.9375 20.875 9.32812 22 12 22C14.625 22 17.0156 20.875 18.7031 19.0469ZM0 13C0 8.73438 2.25 4.79688 6 2.64062C9.70312 0.484375 14.25 0.484375 18 2.64062C21.7031 4.79688 24 8.73438 24 13C24 17.3125 21.7031 21.25 18 23.4062C14.25 25.5625 9.70312 25.5625 6 23.4062C2.25 21.25 0 17.3125 0 13ZM12 13.75C13.1719 13.75 14.2969 13.1406 14.9062 12.0625C15.5156 11.0312 15.5156 9.76562 14.9062 8.6875C14.2969 7.65625 13.1719 7 12 7C10.7812 7 9.65625 7.65625 9.04688 8.6875C8.4375 9.76562 8.4375 11.0312 9.04688 12.0625C9.65625 13.1406 10.7812 13.75 12 13.75Z" fill="white"/>
                            </svg>
                            <span>${event.data.user.name}</span>
                            <span class="mobile-nav-arrow mobile-nav--arrow-right"></span>
                          </button>
                          <div class="main-menu__expandable main-menu-profile" style="padding-left: 1.875rem;">
                              <ul class="menu-list main-menu__1" style="padding-left: 0;">
                                  <li class="menu-list__item">
                                      <a href="/mina-sidor">${Drupal.t(
                                        "Min översikt"
                                      )}</a>
                                  </li>
                                  <li class="menu-list__item">
                                      <a href="/mina-bokningar">${Drupal.t(
                                        "Mina bokningar"
                                      )}</a>
                                  </li>
                                  <li class="menu-list__item">
                                      <a href="/mina-installningar">${Drupal.t(
                                        "Mina personliga uppgifter"
                                      )}</a>
                                  </li>
                                  <li class="menu-list__item">
                                      <a href="/mina-presentkort">${Drupal.t(
                                        "Mina presentkort"
                                      )}</a>
                                  </li>
                                  <li class="menu-list__item">
                                    <a class="profile-menu__link" href="/mina-favourite-events">${Drupal.t(
                                      "Mina favoriter"
                                    )}</a>
                                  </li>
                                  <li class="menu-list__item">
                                      <a href="https://tix.kulturhusetstadsteatern.se/sv/profile/?ReturnUrl=${
                                        window.location.href
                                      }">${Drupal.t("Ändra lösenord")}</a>
                                  </li>
                                  <li class="menu-list__item">
                                      <a href="
                                      https://tix.kulturhusetstadsteatern.se/sv/logout/?ReturnUrl=${
                                        window.location.origin
                                      }/login-redirect?redirect=home">${Drupal.t(
              "Logga ut"
            )}</a>
                                  </li>
                              </ul>
                          </div>
                      </li>
                  </ul>
          `);

            // Add the click handler immediately after appending
            const $profileMobileButton = $(
              ".profile-link-mobile .main-menu__trigger"
            );

            if ($profileMobileButton.length) {
              $profileMobileButton.on("click", function (e) {
                e.preventDefault();
                const expandableMenu = this.nextElementSibling;
                const arrow = this.querySelector(".mobile-nav-arrow");

                // Toggle classes
                expandableMenu.classList.toggle("open");
                arrow.classList.toggle("mobile-nav--arrow-down");
                this.classList.toggle("is-active");

                // Update aria-expanded
                this.setAttribute(
                  "aria-expanded",
                  this.getAttribute("aria-expanded") === "true"
                    ? "false"
                    : "true"
                );
              });
            }
          }

          /* Added localStorage for logged-in status */
          localStorage.setItem("loggedInFavouriteCheck", "true");
        }

        if (event.data.order !== null) {
          // Update cart count
          $(".header__cart-link .count").text(event.data.order.items.length);
          const cartButton = document.querySelector("#header-cart");

          cartButton.addEventListener("click", function (e) {
            // e.preventDefault();

            // Toggle dropdown visibility
            const cartHover = this.querySelector(".header__cart-hover");
            cartHover.classList.toggle("header__cart-hover--active");

            // Create hover content with order items
            let hoverContent = `<div class="header__cart-hover-items">`;
            let totalPrice = 0;

            const groupedItems = {};
            // Group the items
            event.data.order.items.forEach((item) => {
              // Create a key based on name and details
              const key = `${item.name}_${item.details}`;

              if (!groupedItems[key]) {
                groupedItems[key] = {
                  ...item,
                  quantity: 1,
                  totalItemPrice: item.price,
                };
              } else {
                groupedItems[key].quantity += 1;
                groupedItems[key].totalItemPrice += item.price;
              }
              totalPrice += item.price;
            });

            // Remove this line - it was duplicating the total price
            // totalPrice += item.price;

            Object.values(groupedItems).forEach((item) => {
              hoverContent += `
                    <div class="header__cart-item">
                        <div class="header__cart-item-name">${
                          item.name
                        } <p>Pris</p></div>
                        <div class="header__cart-flex-container">
                            <ul class="header__cart-item-details">
                                ${
                                  item.quantity > 1
                                    ? `<li>Biljetter ${item.quantity}</li>`
                                    : ""
                                }
                                <li>
                                    ${item.details}
                                </li>
                            </ul>
                            <div class="header__cart-item-price">${
                              item.totalItemPrice
                            } kr</div>
                        </div>
                    </div>
                `;
            });

            hoverContent += `
                <div class="header__cart-total-price">
                    <p>Totalt
                        <span>${totalPrice}kr</span>
                    </p>
                </div>
                <div class="header__cart-link-container">
                    <a href="https://tix.kulturhusetstadsteatern.se/sv/buyingflow/order/" class="header__cart">Visa varukorg</a>
                </div>
            </div>`;

            // Update hover content
            $(".header__cart-hover").html(hoverContent);
          });

          // Show cart link with styling
          $(".header__cart-link").show().css({
            display: "inline-flex",
            "justify-content": "center",
            "align-items": "center",
            gap: ".25rem",
            border: "none",
          });

          $(".header__cart-link .count").text(event.data.order.items.length);
          $(".header__cart-link").show().css({
            display: "inline-flex",
            "justify-content": "center",
            "align-items": "center",
            gap: ".25rem",
          });
          $(".header__calendar-button-logged-in")
            .show()
            .css("display", "inline-block");
          $(".header__calendar-button-logged-out").hide();
          $(".header").append(
            '<a href="https://tix.kulturhusetstadsteatern.se/sv/buyingflow/order/" class="header__message">' +
              Drupal.t(
                "The tickets are yours soon. Time remaining to finish your booking:"
              ) +
              ' <span class="countdown"></span></a>'
          );

          let distance = Math.round(event.data.order.expires) * 1000;
          let x = setInterval(function () {
            let minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            distance = distance - 1000;
            if (minutes < "10") {
              minutes = "0" + minutes;
            }
            if (seconds < "10") {
              seconds = "0" + seconds;
            }

            $("span.countdown").html(minutes + ":" + seconds);

            if (distance < 0) {
              clearInterval(x);
              $(".header__message").remove();
              $(".header__cart-link").hide();
            }
          }, 1000);
        }
      }
    },
    false
  );
  async function getUserDetails() {
    try {
      const response = await fetch("/api/v2/user-account", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.result.tix_user_data.FirstName) {
        $("#user-name").text(data.result.tix_user_data.FirstName);
      }
      if (data.result.tix_user_data.CompanyName) {
        $("#company-name").text(data.result.tix_user_data.CompanyName);
        if (isSchool(data.result.tix_user_data.Tags)) {
          $("#customer-info")
            .prepend(`<svg class="node--my-account__hero__customer__tag-svg" width="23" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
          <path d="M640 176l-12.8 4.5-14.2 5L320 288 126.3 220.2 80 263v83.8c15.4 25.1 27.8 68.4 0 133.2L0 464s32.5-46.5 48-96.9V256v-7l5.1-4.8 38.9-36L26.9 185.4l-14.2-5L0 176V144l12.8-4.5 14.2-5L320 32 613.1 134.6l14.2 5L640 144v32zM320 237.1L540.4 160 320 82.9 99.6 160l41.9 14.7 172.9-64.8 11.2 30-137 51.4 131.4 46zm-176.4 23l46.6 16.3-13 123.5c4.8 3.5 12.8 8 24.6 12.6C230 423.6 272 432 320 432s90-8.4 118.3-19.4c11.8-4.6 19.8-9.2 24.6-12.6l-13-123.5 46.6-16.3L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.6-147.8zM467.4 396a.7 .7 0 1 0 -1.2-.7 .7 .7 0 1 0 1.2 .7zm-294.8 0a.7 .7 0 1 0 1.2-.6 .7 .7 0 1 0 -1.2 .6z"/>
        </svg>`);
        } else {
          $("#customer-info").prepend(
            `<svg class="node--my-account__hero__customer__tag-svg" width="23" height="23" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H96zM248 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32z"/></svg>`
          );
        }
        $("#customer-info").addClass("my-account__hero__customer");
      } else {
        $("#customer-info").remove();
      }
    } catch (error) {
      console.error("Error", error);
    }
  }
  function getDrupalUser(user) {
    fetch("/api/v2/user-login?format=json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: user.email,
        name: user.name,
        tixly_uid: user.id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        localStorage.setItem("drupal_user", JSON.stringify(data.result));
        syncFavouritesToDB(); // Auto sync (unsynced favourites events after login).
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function logoutDrupalUser(token) {
    fetch("/api/v2/user-logout", {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        localStorage.removeItem("drupal_user");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function checkPendingTags(tags) {
    // Check if user has either of the tags below
    for (let tag of tags) {
      if (
        tag.id === 901 ||
        tag.id === 902 ||
        tag.id === 903 ||
        tag.id === 904 ||
        tag.id === 906 ||
        tag.id === 907
      ) {
        return true;
      }
    }
    return false;
  }

  function checkTags(tags) {
    // Loop through to check tags event.data.user.tags
    // check if user have any of 901, 906, 907
    for (let tag of tags) {
      if (tag.id === 901 || tag.id === 906 || tag.id === 907) {
        return true;
      }
    }
    return false;
  }
  function isSchool(tags) {
    // Loop through to check tags event.data.user.tags
    // check if user have any of 901, 906, 907
    for (let tag of tags) {
      if (tag.Id === 907) {
        return true;
      }
    }
    return false;
  }

  window.khstGetUser = function () {
    return JSON.parse(localStorage.getItem("drupal_user"));
  };
})(jQuery);
